import apiCredentials from "./api-credentials";
import attachments from "./attachments";
import auth from "./auth";
import brands from "./brands";
import brokers from "./brokers";
import call from "./call";
import campaigns from "./campaigns";
import campaignStates from "./campaignStates";
import categoryWeight from "./category-weight";
import commissionStatements from "./commission-statements";
import commissions from "./commissions";
import companies from "./companies";
import connectors from "./connectors";
import connectorCalls from "./connector-calls";
import contacts from "./contacts";
import contracts from "./contracts";
import coverageBenefits from "./coverage-benefits";
import coverageCategories from "./coverage-categories";
import coverages from "./coverages";
import dashboard from "./dashboard";
import discountCodes from "./discount-codes";
import distributions from "./distributions";
import documentTemplates from "./document-templates";
import * as emailTemplates from "./emailTemplate";
import events from "./events";
import flows from "./flows";
import generalCosts from "./general-cost";
import geoZones from "./geo-zones";
import * as idcc from "./idcc";
import insurancePlanCoverages from "./insurance-plan-coverage";
import insurancePlans from "./insurance-plans";
import links from "./link";
import notes from "./notes";
import notifications from "./notifications";
import offers from "./offers";
import organizations from "./organizations";
import organizationParameters from "./organization-parameters";
import poles from "./poles";
import pricers from "./pricers";
import processConfig from "./process-config";
import processStatuses from "./process-statuses";
import processes from "./processes";
import productRangeAdvisorCodes from "./product-range-advisor-codes";
import projects from "./projects";
import qualifications from "./qualifications";
import qualifiers from "./qualifiers";
import quotes from "./quotes";
import referentials from "./referentials";
import reminders from "./reminders";
import sources from "./sources";
import stores from "./stores";
import subscriptions from "./subscription";
import tasks from "./tasks";
import tracers from "./tracers";
import userActivity from "./user-activity";
import users from "./users";
import webhooks from "./webhooks";
import workflows from "./workflows";
import screens from "./screens";
import fieldRegistry from "./field-registry";
import projectRuns from "./project-runs";

const queries = {
  ...attachments,
  ...companies,
  ...contacts,
  ...contracts,
  ...organizations,
  ...organizationParameters,
  ...projects,
  ...auth,
  ...users,
  ...sources,
  ...tracers,
  ...flows,
  ...processes,
  ...insurancePlans,
  ...coverages,
  ...coverageBenefits,
  ...processConfig,
  ...processStatuses,
  ...qualifiers,
  ...qualifications,
  ...webhooks,
  ...notes,
  ...reminders,
  ...quotes,
  ...generalCosts,
  ...idcc,
  ...subscriptions,
  ...commissions,
  ...brokers,
  ...call,
  ...workflows,
  ...pricers,
  ...commissionStatements,
  ...distributions,
  ...referentials,
  ...categoryWeight,
  ...coverageCategories,
  ...insurancePlanCoverages,
  ...offers,
  ...dashboard,
  ...discountCodes,
  ...links,
  ...userActivity,
  ...brands,
  ...stores,
  ...notifications,
  ...events,
  ...poles,
  ...campaigns,
  ...tasks,
  ...campaignStates,
  ...geoZones,
  ...emailTemplates,
  ...productRangeAdvisorCodes,
  ...documentTemplates,
  ...screens,
  ...fieldRegistry,
  ...projectRuns,
  ...connectors,
  ...apiCredentials,
  ...connectorCalls,
};

export default queries;
